/**
 * Pattern d'affichage des éléments gardés par [permissionBlock] quand la permission manque :
 * - 'hide' : l'élément est masqué (display: none) — comportement demandé depuis PRED-3185.
 * - 'lock' : l'élément reste visible mais verrouillé (cadenas + tooltip + snackbar au clic).
 *
 * Changer cette constante bascule TOUTE l'application d'un pattern à l'autre.
 */
export type PermissionUiPattern = 'hide' | 'lock';

export const PERMISSION_UI_PATTERN: PermissionUiPattern = 'hide';
